import { Component } from '@theme/component';

class CouponSlider extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initSlider();
    this.initCopy();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initSlider();
    this.initCopy();
  }

  initSlider() {
    const slider = this.querySelector('.coupon-slider-container');
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Scroll-speed factor
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  initCopy() {
    const tickets = this.querySelectorAll('.coupon-ticket');
    tickets.forEach(ticket => {
      // Avoid binding multiple times
      if (ticket.dataset.copyInitialized) return;
      ticket.dataset.copyInitialized = 'true';

      const codeBox = ticket.querySelector('.coupon-code-box');
      if (!codeBox) return;

      const code = ticket.getAttribute('data-code');

      codeBox.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent card clicks if they do anything else
        this.copyCode(code, codeBox);
      });

      // Also copy when clicking anywhere on the ticket itself
      ticket.addEventListener('click', () => {
        this.copyCode(code, codeBox);
      });
    });
  }

  copyCode(code, codeBox) {
    if (!code || !codeBox) return;
    if (codeBox.innerText === 'COPIED!') return;

    const originalText = codeBox.innerText;

    navigator.clipboard.writeText(code).then(() => {
      codeBox.innerText = 'COPIED!';
      
      const copiedBg = this.getAttribute('data-copied-bg') || '#e6ffea';
      const copiedColor = this.getAttribute('data-copied-color') || '#006400';
      
      codeBox.style.background = copiedBg;
      codeBox.style.color = copiedColor;

      setTimeout(() => {
        codeBox.innerText = originalText;
        codeBox.style.background = '';
        codeBox.style.color = '';
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }
}

if (!customElements.get('coupon-slider')) {
  customElements.define('coupon-slider', CouponSlider);
}
